import i18n from '../VueI18n'

/**
 *
 * @param {Object} talhao Talhao que deve ser validado
 * @param {Array<Object>} talhoes Lista de talhões que devem ser usados para validacao
 */
const validarTalhao = (talhao, talhoes) => {
	if (!isUnique(talhao, talhoes)) {
		return {
			isValid: false,
			message: `${i18n.t('oCodigo')}  "${talhao.tlho_cd_codigo}" ${i18n.t('jaPercenteAUmTalhao')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se o talhão possui valores unicos considerando:
 * - tlho_cd_codigo
 * @param {Object} talhao Código do talhão que deseja saber se é unico
 * @param {Array<Object>} talhoes Lista de talhões que devem ser usados para validacao
 */
function isUnique(talhao, talhoes) {
	return (
		talhoes
			.filter((talhoDaLista) => talhoDaLista.fk_fzda_fazenda === talhao.fk_fzda_fazenda)
			.filter((talhoDaLista) => talhoDaLista.tlho_cd_codigo === talhao.tlho_cd_codigo).length === 0
	)
}

export default validarTalhao
